export default "__VITE_ASSET__ClmGi$50__"